import { cn } from '../../utils/cn';

/**
 * The one empty-state treatment.
 *
 * The app previously had four: a Card with CTA (ClientList page), an emoji
 * block with no CTA (ClientsTable's internal 👥), plain text ("No reports
 * generated yet."), and a dashed-border card (Monitoring). Emoji as
 * empty-state art is the single loudest "startup tool" tell in the product.
 *
 * An empty list is a moment of instruction, not an error: say what belongs
 * here and offer the one action that fills it.
 */
export function EmptyState({ icon: Icon, title, description, action, compact = false, className }) {
	return (
		<div className={cn('flex flex-col items-center justify-center text-center', compact ? 'py-8' : 'py-14', className)}>
			{Icon && (
				<div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 dark:bg-brand-500/10">
					<Icon className="h-5 w-5" />
				</div>
			)}
			<h3 className="text-base font-semibold text-foreground">{title}</h3>
			{description && (
				<p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
			)}
			{action && <div className="mt-5">{action}</div>}
		</div>
	);
}

export default EmptyState;
